import * as types from '../actions/actionsTypes'
import initialState from './initialState'


export default function networkRequest(state = initialState.isFetching, action) {
  if (action.type === types.NETWORK_REQUEST_STATUS) {
    return action.isFetching;
  }
  return state;
}
